import { Box, Flex, Text } from "@chakra-ui/react";
import { WHITE } from "../constants/colors";

function BoxCardsMenus(props: any) {
  return (
    <Box
      width={"100%"}
      // bgColor={WHITE}
      // shadow={"md"}
      height={"fit-content"}
      mt={"0.3%"}
      pt={6}
      mx="auto"
      px={3}
    >
      <Flex flexDir={"column"} height="100%" width="100%" >
        <Flex
          width="100%"
          px={5}
          pt={5}
          bgColor={WHITE}
          gridGap={3}
          flexDirection={"column"}
          mx={"auto"}
          borderTopColor={props.color}
          borderWidth={"5px"}
        >
          <Flex width={"100%"}>
            <Text fontWeight={"bold"} fontSize={"18px"}>
              {props.text}
            </Text>
          </Flex >
          <Flex 
          justifyContent={"flex-start"}
          width={"100%"} >
          {props.children}
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
}
export default BoxCardsMenus;
